import React from "react";
import PanelGroupController from "../../../components/PanelGroupController";
import {fromJS} from "immutable";
import InlineTable from "../../../components/InlineTable";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {Query} from "react-apollo";
import {GET_SHOP_PRODUCT_PRICING} from "../../../queries/inventory";

const FIELDS = fromJS([
  {field: "currency", title: "Currency", type: "string"},
  {field: "value", title: "Value", type: "number"}  
])

const PricingPanel = (props) => {

  let elements = null;
  if (!props.active) {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let variables = {shopId: props.shopId, productSku: props.productId}
    elements = (
      <Query query={GET_SHOP_PRODUCT_PRICING} variables={variables} skip={!props.active}>
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          return (
            <InlineTable
              data={fromJS(data.shopProduct).get("pricing")}
              fields={FIELDS}
              dataType="product_pricing"
              />
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="Pricing" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

PricingPanel.defaultProps = {
  active: true
}

export default PricingPanel;